const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20warriors%20in%20ancient%20Chinese%20palace%2C%20floating%20magical%20particles%2C%20dramatic%20golden%20lighting%2C%20cinematic%20wide%20composition%2C%20high%20quality%20animation%20style%2C%20warm%20color%20palette&width=1200&height=600&seq=crsl-01&orientation=landscape',
    tag: '编辑精选',
    title: '国漫崛起：十部必看国产漫画推荐',
    desc: '近年来国产漫画质量飞速提升，从古风仙侠到科幻悬疑，这些作品代表了国漫的顶尖水准。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20with%20romantic%20couple%20in%20modern%20Seoul%20cityscape%2C%20soft%20pink%20and%20warm%20evening%20light%2C%20beautiful%20cinematic%20composition%2C%20clean%20digital%20art%20style&width=1200&height=600&seq=crsl-02&orientation=landscape',
    tag: '韩漫专题',
    title: '韩漫入坑指南：从零开始的韩漫之旅',
    desc: '韩漫以其独特的画风和紧凑的剧情征服了全球读者，这篇指南带你快速找到适合你的韩漫。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20scene%20with%20school%20life%20and%20fantasy%20elements%20blending%2C%20cherry%20blossoms%2C%20warm%20spring%20lighting%2C%20nostalgic%20atmosphere%2C%20beautiful%20cinematic%20composition&width=1200&height=600&seq=crsl-03&orientation=landscape',
    tag: '日漫经典',
    title: '日漫永恒经典：那些年我们一起追的漫画',
    desc: '从热血少年到治愈日常，这些经典日漫承载了一代人的青春记忆，每一部都值得反复品读。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Vertical%20scroll%20comic%20style%20illustration%20with%20modern%20urban%20romance%20scene%2C%20smartphone%20screen%20displaying%20webtoon%2C%20warm%20cozy%20lighting%2C%20clean%20digital%20art%2C%20contemporary%20aesthetic&width=1200&height=600&seq=crsl-04&orientation=landscape',
    tag: '条漫推荐',
    title: '条漫时代：竖屏阅读新体验完全攻略',
    desc: '专为手机设计的条漫正在改变阅读方式，一滑到底的沉浸体验，这些热门条漫你绝对不能错过。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Mystery%20suspense%20anime%20scene%20with%20detective%20in%20dark%20library%2C%20dramatic%20shadows%2C%20warm%20candle%20light%2C%20atmospheric%20composition%2C%20thriller%20mood%2C%20high%20quality%20illustration&width=1200&height=600&seq=crsl-05&orientation=landscape',
    tag: '悬疑特辑',
    title: '烧脑推荐：十部让你停不下来的悬疑漫画',
    desc: '悬疑推理迷的盛宴，精心挑选十部高能烧脑漫画，每一部都能让你熬夜追到大结局。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-sparkling-line"></i>
            精选
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">编辑精选</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            编辑团队深度策划的专题内容，带你发现更多精彩漫画世界
          </p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden flex flex-col md:flex-row cursor-pointer group"
            >
              <div className="md:w-2/5 shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{ minHeight: '200px' }}
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
              </div>
              <div className="flex-1 p-5 md:p-8 flex flex-col justify-center">
                <span className="inline-flex self-start bg-accent-100 text-accent-700 text-xs font-medium px-2.5 py-1 rounded-full mb-3">
                  {item.tag}
                </span>
                <h3 className="font-heading text-xl md:text-2xl text-foreground-900 mb-3">{item.title}</h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">{item.desc}</p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer">
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}